module.exports = __webpack_public_path__ + "img/project9_7.08f58223.png";